import React from 'react';
import PropTypes from 'prop-types';
import Tag from '4all-ui/components/Tag';
import { styles } from '4all-ui/styles';
import { ORDER_TYPE, parseStatus } from '../../../../helpers/constants';
import parsePayment from '../../../../helpers/payment';
import Formats from '../../../../helpers/formats';
import * as style from './style';
import { selectOrder } from '../../../../actions';

const renderPayment = (method, status, paymentStatus) => {
  const payment = parsePayment(method, status, paymentStatus);
  return (
    <style.DescribeSale>
      {payment.icon} |{' '}
      <style.PaymentLabel color={payment.color}>{payment.label}</style.PaymentLabel>
    </style.DescribeSale>
  );
};

const select = (e, selectOrder, order) => {
  e.preventDefault();
  selectOrder(order.id);
};

const OrderItem = ({ order, selected, selectOrder }) => {
  // const [searchText, setSearchText] = useState('');
  const date = Formats.formatDate(order.timestamp);

  // const classOrder = selected ? 'order-item-container selected' : 'order-item-container';
  const orderDisplay = ORDER_TYPE.find(type => type.id === order.idOrderType).display;
  const orderStatus = parseStatus(order.status);
  if (orderDisplay.first === 'Delivery') {
    orderDisplay.last = order.orderAddress ? order.orderAddress.neighborhood : '';
  }

  return (
    <style.OrderItemContainer
      selected={selected}
      role="button"
      onClick={e => select(e, selectOrder, order)}
    >
      {/* {selected ? <style.ContainerSelected /> : null} */}
      <style.ContentItem>
        <style.ContentOrder>
          <style.Describe>{date}</style.Describe>
          <Tag
            id={`status-${order.id}-${orderStatus.id}`}
            color={orderStatus.color}
            bgColor={orderStatus.bgColor}
            border={`1px solid ${styles.colors.GRAY_LIGHT_2}`}
            customStyles={{
              marginBottom: '0px',
            }}
          >
            {orderStatus.label}
          </Tag>
        </style.ContentOrder>
        <style.ContentClient>
          <h3>{order.id}</h3>
          <style.RightIcon />
          <style.RightInfos>
            <style.ClientName>
              <h4>{order.customer.name || '---'}</h4>
            </style.ClientName>
            <style.RemovalType>
              <span className="text-order-type">Retirada: </span>
              <span
                className="text-order-type"
                style={{ color: styles.colors.GRAY_DARKER, marginLeft: '5px' }}
              >
                {orderDisplay.first}{' '}
                {order.deliveryPersonallyObservation ? ' - Receber em Mãos' : ''}
              </span>
            </style.RemovalType>
          </style.RightInfos>
        </style.ContentClient>
        <style.ContentArea>
          {renderPayment(order.paymentMethod, order.status, order.paymentStatus)}
          <style.DescribeValue>
            {Formats.formatCurrency(order.total.toString())}
          </style.DescribeValue>
        </style.ContentArea>
      </style.ContentItem>
    </style.OrderItemContainer>
  );
};

OrderItem.propTypes = {
  order: PropTypes.object,
  selectOrder: PropTypes.func,
  selected: PropTypes.bool,
};

export default OrderItem;



// WEBPACK FOOTER //
// ./src/components/OrderList/SearchResultsBox/OrderItem/index.js